/**
 * FEAT-15 (Sheet #113): the "N of M answered" line of the confirm shown
 * before the final submit.
 *
 * One population, exactly like the Review banner behind the dialog — on a
 * mixed test (FEAT-11) statements count with the questions there too, and a
 * dialog that disagreed with the screen it sits on would be the worse bug.
 *
 * `current` replaces ONE position's server state with what is on screen. The
 * last unit of a per_question test submits straight from the question, so its
 * answer is not on the server yet when the confirm opens — and must not be put
 * there just to count it (a save finalizes a forward-only position, #112).
 */
export interface SubmitSummary {
  answered: number;
  total: number;
}

export function submitSummary(
  answers: ReadonlyArray<{ position: number; has_answer: boolean }>,
  current?: { position: number; answered: boolean },
): SubmitSummary {
  const answered = answers.filter((a) =>
    current && a.position === current.position ? current.answered : a.has_answer,
  ).length;
  return { answered, total: answers.length };
}
